class MESSAGES {

    static INFO = {
        BROWSER_WARNING: 'Certifique-se de que o seu browser não está a bloquear o download',
    }

    static SUCCESS = {
        SAVED: 'Salvo',
        CHANGED: 'Alterado',
        REMOVED: 'Removido',
        INSERTED: 'Inserido',
        LOGIN_CHANGED: 'Nova sessão detetada',
        APPLIED: 'Aplicado',
        SENT: 'Enviado',
    }

    static ERROR = {
        DEFAULT: 'Ocorreu um erro',
        PRIVACY: 'Obrigatório dar ciência da declaração de privacidade',
        NOT_ALLOWED: 'Não permitido',
        TYPE_UNCHOSEN: 'Escolha o tipo',
        LIST_UNNAMED: 'É preciso dar nome a lista antes de guardá-la',
        USER_INACTIVE: 'Utilizador inativo',
        LOGIN_INVALID: 'Username ou password inválidos',
        NEW_PASS_EMPTY: 'É necessário informar a nova password',
        NEW_PASS_UNCONFIRMED: 'É necessário confimar a password',
        RATE_SKILL: 'É necessário classificar a competência',
        INVALID_FILE: 'Ficheiro inválido',
        NO_FILE_IMPORTED: 'Ficheiro não selecionado',
        NO_LIST_CHECKED: 'Selecione ao menos uma lista',
        WITHOUT_FILE: 'É necessário enviar um ficheiro com o certificado',
        FILE_SIZE: 'Tamanho máximo permitido: 10MB',
        FILE_ALREADY_EXISTS: 'Ficheiro duplicado',
        FILE_NOT_FOUND: 'Ficheiro não encontrado',
        VALIDATOR_NOT_SELECTED: 'É necessário selecionar um validador',
    }

    static QUESTIONS = {
        REMOVE_FROM_TREE: 'Eliminar este elemento e os seus filhos?',
        REMOVE_COLUMN_TREE: 'Apagar a coluna?',
        REQUEST_VALIDATION: 'Solicitar qual tipo de validação? <br><br>(A validação por certificado exige que o utilizador envie um certificado que comprove a sua competência.)',
        POST_VALIDATION: 'Certifique-se que deixou um comentário com o(s) motivo(s) da sua decisão. <br> <br>Publicar decisão?',
        REMOVE_SKILL_FROM_ACTIVITIES_TREE: 'Remover as competências operativas deste elemento da árvore?',
        REMOVE_OP_SKILL_FROM_ACTIVITIES_TREE: 'Remover este elemento da árvore?',
        CHANGE_VALIDATOR: 'Transferir este pedido de validação para outro validador?',
        SENDING_ALERTS: 'Enviar alertas para os validadores que ainda não finalizaram os pedidos de validação?',
        CONFIRM_NEW_TREE_DROP: 'Esse elemento já está incluído na árvore, ao continuar ele será movido para a posição atual. Deseja continuar?',
    }

    static TOOLTIPS = {
        SEND_ALERT_TO_VALIDATORS: 'Enviar alerta para os validadores que ainda não finalizaram os pedidos de validação',
        UNAVAILABLE_DURING_VALIDATION: 'Indisponível durante o processo de validação',
        CAN_VALIDATE_PERMISSION: 'Valida competências onde é claramente Competente\r\nValida competências de subordinados',
        ACCEPT_VALIDATE_PERMISSION: 'Aceitou ser validador onde é claramente Competente\r\nAceitou ser validador de competências de subordinados',
        SKILL_CARD_PERMISSION: 'Consultar cédulas dos subordinados e nos resultados do Encontrar Pessoas',
        CAN_SEARCH_USERS_PERMISSION: 'Pesquisar em toda a organização',
        CAN_MANAGE_SUBORDINATES_ACTIVITIES_PERMISSION: 'Atribuir atividades para subordinados diretos',
    }
}

export { MESSAGES }